module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalDetailsEnvoiBulletinComponent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog tw-max-w-[1350px]"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "head tw-flex tw-items-center tw-mb-4 tw-ml-3.5 tw-w-full"
  }, [_c('div', {
    staticClass: "label tw-mr-3 tw-font-bold"
  }, [_vm._v("Période")]), _vm._v(" "), _c('div', {
    staticClass: "tw-bg-gray-300 tw-pl-2 tw-rounded tw-min-w-[6em] tw-max-h-[1.5em]"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.DisplayMois()) + "\n\t\t\t\t\t")]), _vm._v(" "), (_vm.peutRedistribuer) ? _c('div', {
    staticClass: "area-demande tw-bg-blue-50 tw-flex tw-items-center tw-rounded-lg tw-ml-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info tw-text-blue-600 tw-pl-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-p-2"
  }, [_vm._v("\n\t\t\t\t\t\t\tAttention, toute redistribution engendrera des frais supplémentaires\n\t\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "inp-table noselect"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-checkbox center-flex nohover"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toutSelectionner),
      expression: "toutSelectionner"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.dataReady || !_vm.peutRedistribuer || !_vm.anyDetailSelectable()
    },
    domProps: {
      "indeterminate": _vm.toutSelectionner === undefined,
      "checked": Array.isArray(_vm.toutSelectionner) ? _vm._i(_vm.toutSelectionner, null) > -1 : (_vm.toutSelectionner)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toutSelectionner,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toutSelectionner = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toutSelectionner = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toutSelectionner = $$c
        }
      }, function($event) {
        _vm.toutSelectionnerChanged()
      }]
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "tbody tw-max-h-[640px] tw-min-h-[640px]"
  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.primoboxDetails), function(detail) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-checkbox center-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.estSelectionne),
        expression: "detail.estSelectionne"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.dataReady || !_vm.peutRedistribuer || !_vm.canRedistribuerContrat(detail)
      },
      domProps: {
        "checked": Array.isArray(detail.estSelectionne) ? _vm._i(detail.estSelectionne, null) > -1 : (detail.estSelectionne)
      },
      on: {
        "change": [function($event) {
          var $$a = detail.estSelectionne,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(detail, "estSelectionne", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(detail, "estSelectionne", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(detail, "estSelectionne", $$c)
          }
        }, function($event) {
          _vm.estSelectionneChanged()
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "td cln-numero text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(detail.NumeroContrat) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nomprenomsalarie"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(detail.NomSalarie + ' ' + detail.PrenomSalarie) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-datedebutcontrat text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(detail.DateDebutContrat, "DD/MM/YY")) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-datefincontrat text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(detail.DateFinContrat, "DD/MM/YY")) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-typeenvoi text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.convertTypeEnvoiToString(detail.TypeEnvoiEnum)) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-etatenvoi text-center"
    }, [(_vm.canShowSimpleEtat(detail.EtatEnum)) ? _c('div', [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.convertEtatToString(detail.EtatEnum)) + "\n\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.canShowAnomalieEtat(detail.EtatEnum)) ? _c('div', [_c('span', {
      staticClass: "tw-text-red-700 fas fa-exclamation-triangle"
    }), _vm._v(" "), _c('a', {
      staticClass: "tw-text-red-700 tw-underline",
      on: {
        "click": function($event) {
          _vm.messageAnomalie()
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.convertEtatToString(detail.EtatEnum)) + "\n\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.canShowValiderEtat(detail.EtatEnum)) ? _c('div', [_c('span', {
      staticClass: "tw-text-orange-600 fas fa-exclamation-circle "
    }), _vm._v(" "), _c('a', {
      staticClass: "tw-text-orange-600 tw-underline",
      on: {
        "click": function($event) {
          _vm.validerRedistribution(detail)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.convertEtatToString(detail.EtatEnum)) + "\n\t\t\t\t\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-dateenvoi tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-0"
    }, [(_vm.estRedistribution(detail)) ? _c('div', {
      staticClass: "tw-flex tw-items-center tw-mb-0.5"
    }, [_c('i', {
      staticClass: "fa-solid fa-circle-info tw-text-blue-600 tw-pr-1"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-text-blue-400 tw-text-sm"
    }, [_vm._v("Redistribué le")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tw-text-base"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(detail.DateDistribution, "DD/MM/YY - HH:mm:ss")) + "\n\t\t\t\t\t\t\t\t")])])])
  })], 2)]), _vm._v(" "), (!_vm.dataReady) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    attrs: {
      "id": "Centrerloader"
    }
  }, [_c('loader')], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal blue ml-1 mt-3",
    attrs: {
      "disabled": !_vm.dataReady || !_vm.isAnySelected,
      "type": "button",
      "title": "Distribuer les bulletins dans l'espace sécurisé des salariés"
    },
    on: {
      "click": function($event) {
        _vm.distribuer()
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Distribuer")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1 mt-3",
    attrs: {
      "disabled": !_vm.dataReady,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Détail de l'envoi")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-numero nohover",
    attrs: {
      "title": "Numéro contrat"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Numéro contrat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-nomprenomsalarie nohover",
    attrs: {
      "title": "Nom et prénom du salarié"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom/Prénom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-datedebutcontrat nohover",
    attrs: {
      "title": "Date de début contrat"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date de début contrat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-datefincontrat nohover",
    attrs: {
      "title": "Date de fin contrat"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date de fin contrat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-typeenvoi nohover",
    attrs: {
      "title": "Type d'envoi"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Type d'envoi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-etatenvoi nohover",
    attrs: {
      "title": "Etat de l'envoi"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Etat de l'envoi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-dateenvoi nohover",
    attrs: {
      "title": "Date / heure envoi"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date / heure envoi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-checkbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-numero"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nomprenomsalarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-datedebutcontrat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-datefincontrat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-typeenvoi"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-etatenvoi"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-dateenvoi"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-download"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7242987e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Primobox/envoiBulletins/modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin.vue.html
// module id = ey9v
// module chunks = 2